import PeacefulnessIconDetailed from 'components/icons/PeacefulnessDetailed'
import RejuvinationIconDetailed from 'components/icons/RejuvenationDetailed'
import HumanConnectionIconDetailed from 'components/icons/HumanConnectionDetailed'
import JoyIconDetailed from 'components/icons/JoyDetailed'
import UnpluggedIconDetailed from 'components/icons/UnpluggedDetail'
import FreedomIconDetailed from 'components/icons/FreedomDetail'
import SelfDiscoveryIconDetailed from 'components/icons/SelfDiscoveryDetailed'
import ExcitementIconDetailed from 'components/icons/ExcitementDetailed'
import SpontaneityIconDetailed from 'components/icons/SpontanietyDetailed'
import ChallengeIconDetailed from 'components/icons/ChallengeDetailed'
import GroundednessIconDetailed from 'components/icons/GroundednessDetailed'
import SlownessIconDetailed from 'components/icons/SlownessDetailed'
import type { FulfillingMomentName } from '../types'

const IconDetail = ({ momentName }: { momentName: FulfillingMomentName }) => {
  switch (momentName) {
    case 'peacefulness':
      return <PeacefulnessIconDetailed />
    case 'rejuvenation':
      return <RejuvinationIconDetailed />
    case 'groundedness':
      return <GroundednessIconDetailed />
    case 'slowness':
      return <SlownessIconDetailed />
    case 'human connection':
      return <HumanConnectionIconDetailed />
    case 'joy':
      return <JoyIconDetailed />
    case 'unplugged':
      return <UnpluggedIconDetailed />
    case 'freedom':
      return <FreedomIconDetailed />
    case 'self-discovery':
      return <SelfDiscoveryIconDetailed />
    case 'excitement':
      return <ExcitementIconDetailed />
    case 'spontaneity':
    case 'spontaniety':
      return <SpontaneityIconDetailed />
    case 'challenge':
      return <ChallengeIconDetailed />
    default:
      return <svg />
  }
}

export default IconDetail
